import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  spacing,
  fontFamilies,
  lineHeights,
  fontSizes,
}: Theme) => ({
  content: {
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    margin: '0 0 12px',
    [breakpoints.up('md')]: {
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
  },
  multiContent: {
    '& p': {
      fontSize: fontSizes.xs,
      lineHeight: lineHeights.sm,
      [breakpoints.up('md')]: {
        fontSize: fontSizes.sm,
        lineHeight: lineHeights.md,
      },
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  actions: {
    display: 'grid',
    gap: spacing(2),
  },
}));
